import { React, useEffect, useState, useRef } from 'react'
import FcModuleStyle from '../styles/fc.module.css';
import { expert_opinion} from '../services/api';
import { errorMsg } from '../../../helper/helpers';
import Button from '../../common/Button';
import uparrow from '../assets/uparrow.png';
import downarrow from '../assets/downarrow.png';
import profile from '../assets/profile.png';
import cross_sign from '../assets/cross_sign.png';
import info from '../assets/info.png';
import askAI from '../assets/askAI.png';
import askAI1 from '../assets/askAI1.PNG';
import increase_prediction from '../assets/increase_prediction.png';
import decrease_prediction from '../assets/decrease_prediction.png';

const CurrentDecision = ({ simObj, setSimObj, formatNum, setError, toggleSimulation, setToggleSimulation, isRequestLoading, setIsShowPlaceOrder, getMonth , setIsCurrDecisionActive,expertOpinion, isExpertOpinion, setIsExpertOpinion,setIsAskAi,fcPopup, setFcPopup,isOverlay}) => {
    const [forecast, setForecast] = useState({"regular": 0,"midgrade":0,"premium":0});
    const [isEnable, setIsEnable] = useState(false);
    const [isDecisionSubmitted, setIsDecisionSumbmitted] = useState(false);
    // let forecast_list = ["Regular","Midgrade","Premium"];
    const [forecastList,setForecastList] = useState([]);
    const closeBtnRef = useRef(null);
    const regularInputRef = useRef(null);
    const updateForeCast = (event,forecast_type) =>{  
        if(/^\d*$/.test(event.target.value)){
            switch(forecast_type){
                case "regular": 
                    setForecast({"regular": Number(event.target.value),"midgrade":forecast.midgrade,"premium":forecast.premium});
                    break;
                case "midgrade": 
                    setForecast({"regular": forecast.regular,"midgrade":Number(event.target.value),"premium":forecast.premium});
                    break;
                case "premium": 
                    setForecast({"regular": forecast.regular,"midgrade":forecast.midgrade,"premium":Number(event.target.value)});
                    break;
            }
        }
    }
    const increaseForecastNumber = (forecast_type) =>{ 
        const default_value = 100;
        const step_value = 10;
        switch(forecast_type){
            case "regular": 
                setForecast({"regular": (forecast.regular > 0) ? (forecast.regular + step_value) : default_value,"midgrade":forecast.midgrade,"premium":forecast.premium});
                break;
            case "midgrade": 
                setForecast({"regular": forecast.regular,"midgrade":(forecast.midgrade > 0) ? (forecast.midgrade + step_value) : default_value,"premium":forecast.premium});
                break;
            case "premium": 
                setForecast({"regular": forecast.regular,"midgrade":forecast.midgrade,"premium":(forecast.premium > 0) ? (forecast.premium + step_value) : default_value});
                break;
        }
    }
    const decreaseForecastNumber = (forecast_type) =>{
        const default_value = 100;
        const step_value = 10;
        switch(forecast_type){
            case "regular": 
                setForecast({"regular": (forecast.regular < 110 || forecast.regular <= 0 || forecast.regular == undefined) ? 0 : (forecast.regular - step_value),"midgrade":forecast.midgrade,"premium":forecast.premium});
                break;
            case "midgrade": 
                setForecast({"regular": forecast.regular,"midgrade":(forecast.midgrade < 110 || forecast.midgrade <= 0 || forecast.midgrade == undefined) ? 0 : (forecast.midgrade - step_value),"premium":forecast.premium});
                break;
            case "premium": 
                setForecast({"regular": forecast.regular,"midgrade":forecast.midgrade,"premium":(forecast.premium < 110 || forecast.premium <= 0 || forecast.premium == undefined) ? 0 : (forecast.premium - step_value)});
                break;
        }
       
    }
    const isOptionsUpdated = ()=> {
        let optionsChanged = false
        if(simObj?.optionsAvailable?.REGULAR && !simObj?.optionsAvailable?.MIDGRADE && !simObj?.optionsAvailable?.PREMIUM){
            optionsChanged = forecast.regular > 0 && forecast.regular >= 100
        }
        else if(simObj?.optionsAvailable?.REGULAR && simObj?.optionsAvailable?.MIDGRADE && !simObj?.optionsAvailable?.PREMIUM){
            optionsChanged = (forecast.regular > 0 && forecast.regular >= 100) && (forecast.midgrade > 0 && forecast.midgrade >= 100)
        }
        else if(simObj?.optionsAvailable?.REGULAR && simObj?.optionsAvailable?.MIDGRADE && simObj?.optionsAvailable?.PREMIUM){
            optionsChanged = (forecast.regular > 0 && forecast.regular >= 100) && (forecast.midgrade > 0 && forecast.midgrade >= 100) && (forecast.premium > 0 && forecast.premium >= 100)
        }
        return optionsChanged;
    }
    const isEnableOrNot = () =>{        
        setIsEnable((forecast.regular + forecast.midgrade + forecast.premium) <= 200000 && isOptionsUpdated()); 
        return ((forecast.regular + forecast.midgrade + forecast.premium) <= 200000 && isOptionsUpdated())
    }
    const submitDecision = () =>{
        setIsEnable(false);
        setIsDecisionSumbmitted(true);
        setToggleSimulation(true);
        setSimObj((prevObj)=>({
            ...prevObj,
            ['actions']:{
                ...prevObj.actions,
                ['foreCastDemands']: {
                    "REGULAR": forecast.regular,
                    "MIDGRADE":forecast.midgrade,
                    "PREMIUM": forecast.premium
                }
            }
        }))
    }
    // const openExpertOpinion  = () =>{ 
    //     setIsExpertOpinion(true);
    //     setIsCurrDecisionActive(false);
    //     const expOpiObj = {
    //         "id": simObj?.id,
    //         "userid": simObj?.userid,
    //         "simulationname": "FC",
    //         "executioninstanceid": simObj?.executioninstanceid,
    //         "completed": simObj?.completed,
    //         "currentstep": simObj?.currentstep
    //     }
    //     expert_opinion(expOpiObj, simObj.sessionid).then((response) => {
    //         if (typeof response != 'undefined') {
    //             setExpertOpinion(response?.data);
    //         }
    //       }).catch((error) => {
    //         setError(errorMsg);
    //         console.log(error);
    //       });
    // }
    const setExpertAdviceTaken = () =>{ 
        setIsAskAi(true);
        setIsCurrDecisionActive(true);
        setIsExpertOpinion(false);
        setSimObj((prevObj)=>({
            ...prevObj,
            ['actions']:{
                ...prevObj.actions,
                ['executionDate']: getMonth(prevObj?.currentstate?.statemonth) + " " + prevObj?.currentstate?.stateyear,
                ['expertAdviceTaken']: true
            }
        }));
    }
   const closeExpertAdviceTaken = () =>{ 
        setIsAskAi(true);
        setIsExpertOpinion(false);
        (!isOverlay) && setExpertAdviceTaken();
        setIsCurrDecisionActive(true);
        
        // Shift focus to Regular input
        if (regularInputRef.current) {
            regularInputRef.current.focus();
        }
    };    
    useEffect(()=>{
        isEnableOrNot();
    },[forecast])
    useEffect(()=>{
        isEnableOrNot() && setIsEnable(true);
        setIsDecisionSumbmitted(false);
    },[simObj?.currentstate?.monthsleft])
    useEffect(()=>{
        setForecast({"regular": simObj?.foreCastDemands?.REGULAR || 0,"midgrade":simObj?.foreCastDemands?.MIDGRADE || 0,"premium":simObj?.foreCastDemands?.PREMIUM || 0})
    },[])
    useEffect(()=>{
        if(simObj?.optionsAvailable){
            let optionsAvailable = simObj?.optionsAvailable
            let forecast_list = Object.keys(optionsAvailable).filter(key => optionsAvailable[key] === 1);
            setForecastList(forecast_list)
        }
    },[simObj?.optionsAvailable])
    useEffect(() => {
        if (isExpertOpinion && closeBtnRef.current) {
        closeBtnRef.current.focus();
        }
    }, [isExpertOpinion]);
    // useEffect(()=>{
    //     if(isExpertOpinion){
    //     document.getElementsByClassName(`${FcModuleStyle["expert-opinion"]}`)[0].querySelector(`.${FcModuleStyle['header-container']} h3`).tabIndex = -1;
    //     document.getElementsByClassName(`${FcModuleStyle["expert-opinion"]}`)[0].querySelector(`.${FcModuleStyle['header-container']} h3`).focus();
    //     }
    //     else{
    //     document.getElementsByClassName(`${FcModuleStyle["ask-user"]}`)[0].querySelector(`.container button`).focus();
    //     }
    // },[isExpertOpinion])
    return (
        <div className={`${FcModuleStyle["current-decision"]}`}>
            {
                !isExpertOpinion ?
                    <div className={`${FcModuleStyle["forecast-decision"]}`}>
                        <div>
                            <div className={`${FcModuleStyle['decisions-table']}`}>
                                <p>Forecast for {getMonth(simObj?.currentstate?.statemonth) + " " + simObj?.currentstate?.stateyear}</p>
                                <div className={`${FcModuleStyle['decision-table-parent']}`}>
                                    <table className="ui celled table unstackable">
                                        <tbody>
                                            {
                                                forecastList.map((item,index)=>
                                                (<tr key={index}>
                                                        <td>
                                                            {item} 
                                                        </td>
                                                        <td>
                                                            <div className={`${FcModuleStyle['inputBox']}`}>
                                                                {/* Hidden instruction for screen reader users */}
                                                                <p id="forecastInstruction" className="sr-only">
                                                                    Activating the increase or decrease buttons will update the value in the forecast input field.
                                                                </p>
                                                                <span aria-live='assertive' aria-atomic='true' className='sr-only'>{item} {forecast[item.toLowerCase()]} gallons</span>
                                                                <button className={`${FcModuleStyle['arrow-btn']}`} disabled={simObj.status == 'COMPLETED'} onClick={()=>{decreaseForecastNumber(item?.toLowerCase())}} aria-label={`${item}: Decrease Cast by 10`} aria-describedby='forecastInstruction'><img src={downarrow} alt="down arrow" /></button>
                                                                <input type="text" ref={item === "Regular" ? regularInputRef : null} disabled={simObj.status == 'COMPLETED'} value={forecast[item?.toLowerCase()]} onChange={(event)=> updateForeCast(event,item?.toLowerCase())} maxLength = "6" aria-label={`${item}: `} />
                                                                <button className={`${FcModuleStyle['arrow-btn']}`} disabled={simObj.status == 'COMPLETED'} onClick={()=>{increaseForecastNumber(item?.toLowerCase())}} aria-label={`${item}: Increase Cast by 10`} aria-describedby='forecastInstruction'><img src={uparrow} alt="up arrow" /></button>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <span>Gallons</span>
                                                            </div>
                                                        </td>
                                                    </tr>)
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className={`${FcModuleStyle['avail-invest-list-controls']}`}>
                                <div>
                                    <p>
                                        {!isDecisionSubmitted && !isOptionsUpdated() && (forecast.regular + forecast.midgrade + forecast.premium) <= 200000 && !simObj?.completed  && <span style={{"color":"#B90000"}}>Forecast demand can not be less than 100!</span>}
                                        {!isDecisionSubmitted && (forecast.regular + forecast.midgrade + forecast.premium) > 200000 && !simObj?.completed  && <span style={{"color":"#B90000"}}>Total forecast should not exceed 2,00,000!</span>}
                                        {isDecisionSubmitted && <span role="alert" style={{"color":"black","font-style":"italic","font-weight":"bold","font-size":"12px","display":"flex","alignItems":"center"}}><img style={{"width":"15px","margin-top":"2px"}} src={info} alt="info" />Saving your current decision...</span>}

                                    </p> 
                                    {/* <Button btnName="Skip" btnWidth={70} customBtnStyle={{ background: "transparent", color: "#B2347B", border: "1px solid #B2347B" }} /> */}
                                    <Button btnName="Submit" disabled={!isEnable || simObj?.completed} clickEventHandler={submitDecision} id="submitBtn" btnWidth={80}/>
                                </div>
                            </div>

                        </div>
                    </div>
                    :
                    <div className={`${FcModuleStyle["expert-opinion"]}`}>
                        <div className={`${FcModuleStyle['header-container']}`}>
                            <h3>Expert Opinion</h3>
                            <button className='closeExpertAdviceTaken' ref={closeBtnRef} onClick={() => closeExpertAdviceTaken()} aria-label='close'><img src={cross_sign} alt="" aria-hidden="true" role='presentation' /></button>
                        </div>
                        <p>Based on my analysis, I believe demand for gas will be <span>&#177;</span>20% of the amounts I've provided you below. Remember to review incoming information and historical data to refine your forecast. Good luck!</p>
                        <div>
                            <img src={askAI1} />
                            <table className="ui celled table unstackable">
                                <tbody>
                                    {
                                        forecastList.map((item,index)=>
                                         ( <tr key={index}>
                                            <td>
                                                {item}
                                            </td>
                                            <td>
                                                {expertOpinion[item.toUpperCase()]}
                                            </td>
                                            <td>
                                                Gallons
                                            </td>
                                         </tr>)
                                        )
                                    }
                                </tbody>    
                            </table>
                            <div>
                                <Button btnName="Ok" btnWidth={70} clickEventHandler={()=>{setExpertAdviceTaken()}}/>
                            </div>
                        </div>
                    </div>
            }
        </div>



    )
}

export default CurrentDecision
